module.exports = __webpack_public_path__ + "static/media/sv.5ad93723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sv.png
// module id = 1988
// module chunks = 0